export default __webpack_public_path__ + "static/media/about-me.e06dad56.jpg";